module.exports = __webpack_public_path__ + "img/img39.c82bc94a.png";